/* eslint-disable @typescript-eslint/no-explicit-any */
import { switchMap, first } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { fromPaymentMethodsActions, paymentMethodsQuery, PaymentMethodsState } from '../../+state';

/**
 * Gets CreditBundles for manage-auto-top-up screen
 */
@Injectable()
export class CreditBundlesResolver {
  constructor(private _store: Store<PaymentMethodsState>) {}

  /*
   * Resolve CreditBundles
   * 1. Selects getCreditBundles from the store
   * 3. Check if CreditBundles is present
   * - If state is empty:
   *   1. Call getCreditBundles
   * 4. Return CreditBundles from store.
   */
  public resolve(): Observable<any> {
    return this._store.select(paymentMethodsQuery.getCreditBundles).pipe(
      switchMap(CreditBundles => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        // if (!CreditBundles) {
        this.getCreditBundles();
        // }

        return of(CreditBundles);
      }),
      first()
    );
  }

  /*
   * trigger fetching CreditBundles
   * 1. Dispatch getPaymentMethods action
   */
  private getCreditBundles() {
    this._store.dispatch(fromPaymentMethodsActions.getCreditBundles());
  }
}
